import { UiQuesDetail, UiPopupContainer } from "./QuestDetail.style";
import { useState, useMemo, useEffect } from "react";
import { useMachine } from "@xstate/react";
import { fetchMachine, FetchEventType, FetchStates } from "machines/fetchMachine";
import { getRecordDetail } from "api/convert";
import { Table, Pagination, Button, Icon, Upload, Select, Loading } from "common-components";
import { Modal, Tabs, Image, Checkbox, DatePicker } from "antd";
import { getTime, format, set } from "date-fns";
import { FileCheck } from "components";
import { getQuestionHtml } from "api/bank";

export const QuestDetail = ({ fileUID, eduSubject, onCancel }) => {
	const showCodeList = ["CORE_ACCOMPLISHMENT", "PERFORMANCE", "LEARN_CONTENT", "KNOWLEDGE"];

	const [detailEduSubject, setDetailEduSubject] = useState("");
	const [bookTagPath, setBookTagPath] = useState("");
	const [bookTagIsListen, setBookTagIsListen] = useState(false);
	const [detailPage, setDetailPage] = useState(1);

	const onDetailPageChange = (currentPage) => {
		setDetailPage(currentPage);
	};

	const [stateRecordDetail, sendRecordDetail] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data } = await getRecordDetail(event.eduSubject, event.fileUID);
				return {
					detailList: data,
				};
			},
		},
	});

	const { detailList } = stateRecordDetail.context.result || {};

	const targetDetail = useMemo(() => {
		if (!detailList) return {};
		return detailList[detailPage - 1];
	}, [detailPage, detailList]);

	const toggleDetailVisible = (item) => {
		setDetailPage(1);
		setBookTagPath("");
		setBookTagIsListen(false);
		const { eduSubject, fileUID } = item;
		sendRecordDetail(FetchEventType.Fetch, {
			eduSubject,
			fileUID,
		});
		setDetailEduSubject(eduSubject);
	};

	const targetSelectOptions = useMemo(() => {
		let result = [];
		if (Object.keys(targetDetail).length === 0 || !targetDetail.detailImage) return result;

		result =
			targetDetail?.detailImage.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: false,
			})) || [];
		if (targetDetail.soundtracks) {
			const listenList = targetDetail.soundtracks.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: true,
			}));
			result = result.concat(listenList);
		}
		return result;
	}, [targetDetail]);

	useEffect(() => {
		if (targetDetail && JSON.stringify(targetDetail) !== "{}") {
			sendGetQuestionHtml(FetchEventType.Fetch, {
				eduSubject: detailEduSubject,
				uid: targetDetail.uid,
			});
		}
	}, [targetDetail]);

	useEffect(() => {
		toggleDetailVisible({
			eduSubject: eduSubject,
			fileUID,
		});
	}, [fileUID, eduSubject]);

	const [stateGetQuestionHtml, sendGetQuestionHtml] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data, isSuccess, message } = await getQuestionHtml(event.eduSubject, event.uid);
				return {
					questionHtml: data,
					isSuccess,
					message,
				};
			},
		},
	});

	const { questionHtml } = stateGetQuestionHtml.context.result || {};

	const onSelectBookTag = (path) => {
		const isListen = targetSelectOptions.find((item) => item.value === path).isListen;
		setBookTagPath(path);
		setBookTagIsListen(isListen);
	};

	return (
		<UiQuesDetail
			open
			// open={true}
			onCancel={onCancel}
			getContainer={document.getElementById("CheckListPage")}
			width="75%"
			zIndex={1010}
			footer={
				<Pagination
					textcolor="#000"
					total={detailList?.length || 0}
					defaultPageSize={1}
					variant="white"
					current={detailPage}
					onChange={onDetailPageChange}
				/>
			}>
			<UiPopupContainer id="quesTab">
				<Tabs
					defaultActiveKey="1"
					tabBarExtraContent={
						<>
							{targetDetail?.questionPdf ? (
								<Button.IconButton
									variant="blue"
									type="outLined"
									iconName="picture_as_pdf"
									onClick={() => {
										window.open(targetDetail.questionPdf, "_blank");
									}}>
									PDF
								</Button.IconButton>
							) : (
								""
							)}
						</>
					}>
					<Tabs.TabPane tab={"線上測驗解析結果"} key="1">
						{questionHtml && <FileCheck key={questionHtml} questionHtml={questionHtml}></FileCheck>}
					</Tabs.TabPane>

					<Tabs.TabPane
						tab={
							<>
								<Icon name="widgets" />
								解析狀態
							</>
						}
						key="2">
						<div className="container">
							<div className="content">
								<div className="title">題目</div>
								<div className="bookTag">
									<Select
										label="解析書籤名稱:"
										options={targetSelectOptions}
										value={bookTagPath}
										onChange={(val) => {
											onSelectBookTag(val);
										}}
									/>
								</div>
								<div className="img">
									{bookTagIsListen ? (
										<audio controls src={bookTagPath || "error"}>
											Your browser does not support the
											<code>audio</code> element.
										</audio>
									) : (
										<Image
											src={bookTagPath || "error"}
											preview={{
												getContainer: document.getElementById("quesTab"),
											}}
											fallback="data:image/png;base64,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"
										/>
									)}
								</div>
							</div>
							<div className="content">
								<div className="title">基本資料</div>
								<div className="meta">
									編號:
									<span className="metaContent">{targetDetail?.uid}</span>
								</div>
								{targetDetail?.metadata &&
									targetDetail.metadata.map((meta, index) => {
										return (
											<div className="meta" key={index}>
												{`${meta.name}: `}
												{meta.content.map((content, contentIndex) => {
													return (
														<span className="metaContent" key={contentIndex}>
															{new Set(showCodeList).has(meta.code) ? content.code : content.name}
														</span>
													);
												})}
											</div>
										);
									})}
							</div>
						</div>
					</Tabs.TabPane>

					<Tabs.TabPane
						tab={
							<>
								<Icon name="visibility" />
								檢視更多
							</>
						}
						key="3">
						<div className="container">
							<div className="content">
								<div className="title">題目</div>
								<div className="img">
									<Image
										src={targetDetail?.questionImage || "error"}
										preview={{
											getContainer: document.getElementById("quesTab"),
										}}
										fallback="data:image/png;base64,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"
									/>
								</div>
								<ul className="info">
									<li>
										入庫時間:{" "}
										{targetDetail?.createTime && format(new Date(targetDetail.createTime), "yyyy-MM-dd HH:mm")}
									</li>
									<li>最後修改時間: {targetDetail?.updateTime}</li>
								</ul>
							</div>
							<div className="content">
								<div className="title">基本資料</div>
								<div className="meta">
									編號:
									<span className="metaContent">{targetDetail?.uid}</span>
								</div>
								{targetDetail?.metadata &&
									targetDetail.metadata.map((meta, index) => {
										return (
											<div className="meta" key={index}>
												{`${meta.name}: `}
												{meta.content.map((content, contentIndex) => {
													return (
														<span className="metaContent" key={contentIndex}>
															{new Set(showCodeList).has(meta.code) ? content.code : content.name}
														</span>
													);
												})}
											</div>
										);
									})}
							</div>
						</div>
					</Tabs.TabPane>
				</Tabs>
			</UiPopupContainer>
		</UiQuesDetail>
	);
};
